module.exports = __webpack_public_path__ + "static/media/ic-contactus-phone.ad6ba4a5.svg";